import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Outlet, Route, Routes, useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import Navbar from "./components/NavBar";
import Loader from "./components/Loader";
import Login from "./pages/auth/Login";
import Home from "./pages/home";
import User from "./pages/user";
import Account from "./pages/account";
import Cession from "./pages/cession";
import Discussion from "./pages/discussion";
import Levee from "./pages/levee";
import Investisseur from "./pages/investisseur";
import Valuation from "./pages/valuation";
import api from "./services/api";
import useStore from "./services/store";
import TopBar from "./components/TopBar";
import Notation from "./pages/notation";
import Question from "./pages/question";
import LeveeService from "./pages/levee-service";
import CessionService from "./pages/cession-service";
import BuyerService from "./pages/buyer-service";
import NDA from "./pages/nda";

const App = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<Login />} />
          </Route>

          <Route element={<ProtectedLayout />}>
            <Route path="/home" element={<Home />} />
            <Route path="/user/*" element={<User />} />

            <Route path="/cession/*" element={<Cession />} />
            <Route path="/levee/*" element={<Levee />} />
            <Route path="/investisseur/*" element={<Investisseur />} />

            <Route path="/valorisation/*" element={<Valuation />} />
            <Route path="/levee-service/*" element={<LeveeService />} />
            <Route path="/cession-service/*" element={<CessionService />} />
            <Route path="/buyer-service/*" element={<BuyerService />} />

            <Route path="/discussion/*" element={<Discussion />} />
            <Route path="/nda/*" element={<NDA />} />
            <Route path="/notation/*" element={<Notation />} />
            <Route path="/question/*" element={<Question />} />
            <Route path="/account" element={<Account />} />
          </Route>
          <Route path="*" element={<Navigate to="/home" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </>
  );
};

const AuthLayout = () => {
  const { user } = useStore();

  if (user) return <Navigate to="/" replace={true} />;
  return (
    <div className="flex justify-center w-screen h-screen pt-[15%]">
      <Outlet />
    </div>
  );
};

const ProtectedLayout = () => {
  const { user, setUser } = useStore();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    api
      .get("/admin/refresh")
      .then((res) => {
        if (res.ok) {
          setUser(res.user);
          api.setToken(res.token);
        } else {
          setUser(null);
          navigate("/login");
        }
        setLoading(false);
      })
      .catch(() => setUser(null));
  }, []);

  if (loading) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Loader />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace={true} />;

  return (
    <>
      <div className="flex h-screen">
        <nav className="w-60 h-screen sticky top-0">
          <Navbar />
        </nav>
        <main className="flex-1 h-full overflow-auto">
          <div className="h-14 border-b border-secondary">
            <TopBar />
          </div>
          <Outlet />
        </main>
      </div>
    </>
  );
};

export default App;
